"use client";

import { useState, type ReactNode } from "react";
import {
    QueryClient,
    QueryClientProvider,
} from "@tanstack/react-query";

let queryClient: QueryClient | null = null;

const getQueryClient = () => {
    if (!queryClient) {
        queryClient = new QueryClient({
            defaultOptions: {
                queries: {
                    refetchOnWindowFocus: false,
                    retry: 1,
                },
            },
        });
    }

    return queryClient;
};

interface ReactQueryProviderProps {
    children: ReactNode;
}



export function ReactQueryProvider({ children }: ReactQueryProviderProps) {
    const [client] = useState(() => getQueryClient());

    return (
        <QueryClientProvider client={client}>
            {children}
        </QueryClientProvider>
    );
}


